import autobind from "autobind-decorator";
import * as React from "react";
import ProgressiveImage from "react-progressive-image-loading";
import * as smoothScroll from "smoothscroll";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import { Button, FS, KitOverview, KITS, MailingList, Quotes, Resources, Text, Thumbnail } from "../components";

import developmentPreview from "./elements-preview.jpg";
import development from "./elements.jpg";

type ClassNames = "header" | "left" | "right" | "kits" | "thumbnails" | "description" | "link";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    header: {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.down("sm")]: {
            textAlign: "center"
        }
    },
    left: {
        width: "50vw",
        paddingLeft: theme.spacing.unit * 4,
        paddingRight: theme.spacing.unit * 4,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            textAlign: "center",
            marginBottom: theme.spacing.unit,
            paddingLeft: theme.spacing.unit,
            paddingRight: theme.spacing.unit
        }
    },
    right: {
        height: "100vh",
        width: "50vw",
        backgroundPosition: "left center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    kits: {
        backgroundColor: "#fafafa",
        justifyContent: "center",
        textAlign: "center",
        paddingTop: theme.spacing.unit * 4,
        paddingBottom: theme.spacing.unit * 4,
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit
    },
    thumbnails: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        flexWrap: "wrap"
    },
    description: {
        marginLeft: "14%",
        marginRight: "14%",
        [theme.breakpoints.down("sm")]: {
            marginLeft: 0,
            marginRight: 0,
        }
    },
    link: {
        color: theme.typography.body1.color
    }
});

class Home extends React.Component<WithStyles<ClassNames>> {

    public renderImage = (src: string, style: React.CSSProperties) => (
        <div
            className={this.props.classes.right}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
        />
    );

    public render() {
        const {classes} = this.props;
        const contactUs = <a className={classes.link} href="mailto:wcandillon@gmail.com">contact us</a>;
        return (
            <div>
                <FS className={classes.header}>
                    <div className={classes.left}>
                        <Text variant="title1">
                        Premium React Native Starter Kits
                        </Text>
                        <Text variant="important">
                        Turnkey solutions for your next iOS and Android project.
                        </Text>
                        <Button onClick={this.scrollToKits}>
                            Discover
                        </Button>
                    </div>
                    <ProgressiveImage
                        preview={developmentPreview}
                        src={development}
                        render={this.renderImage}
                    />
                </FS>
                <div id="kits" className={classes.kits}>
                    <div className={classes.description}>
                        <Text variant="title2" align="center">
                        Elegant Bootstraps for Your Next App
                        </Text>
                        <Text align="center">
These React Native starter kits are designed for both iOS and Android.
The visual design can easily be customized and all aspects of the app are implemented:
from navigation to state management.
Statically typed, based on the latest React Native components, and with no native dependencies,
this is the highest quality codebase you can get.
If you have any questions, please {contactUs}.
                        </Text>
                    </div>
                    <div className={classes.thumbnails}>
                    {KITS.map(kit => <Thumbnail key={kit.id} {...{kit}} />)}
                    </div>
                </div>
                <Quotes />
                <Resources />
                <MailingList />
                {KITS.map((kit, i) => <KitOverview key={kit.id} reverse={i % 2 !== 0} {...{kit}} />)}
            </div>
        );
    }

    @autobind
    private scrollToKits() {
        smoothScroll(document.getElementById("kits"));
    }
}

export default withStyles(styles)(Home);



// WEBPACK FOOTER //
// ./src/home/Home.tsx